module.exports = __webpack_public_path__ + "img/calligraphy-subject-icon1.11776556.png";